module.exports = __webpack_public_path__ + "media/packs/images/markers/pol-e3ed2f45960994e060d566617bd60ffb.svg";